<div class="pb-30 pt-70">
  <div class="container">
    <div class="row">
      <app-article [pageName]="'MY_BOOKINGS'" (pageTeacherDataLoaded)="handlePageData($event)"></app-article>
      <!-- Left Section -->
      <div class="col-lg-8 col-md-8 col-sm-12">
        <div class="row">
          <div class="col-12 mt-10">
            <!-- <div class="info-text txt-regular fs-14">
              <p>
                <i class="bi bi-bell-fill pr-5"></i>Schools can see how often
                you respond to booking requests. Make sure you respond to keep
                getting booked.
              </p>
            </div> -->
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-10">
            <div class="form-floating flex-fill left-labeled">
              <label for="bookingStatus">Booking status</label>
              <select id="bookingStatus" name="bookingStatus" class="form-select mb-6 c-p"
                [(ngModel)]="selectedBookingStatus" (change)="onBookingStatusChange($event)"
                aria-label="Search by booking status">
                <option value="P" selected>Pending</option>
                <option value="B">Booked</option>
                <option value="NB">Not booked</option>
              </select>
            </div>
          </div>
        </div>

        <ng-container [ngSwitch]="selectedBookingStatus">
          <!-- Pending Bookings -->
          <ng-container *ngSwitchCase="'P'">
            <ng-container *ngIf="bookingsData.length > 0; else noPending">
              <div class="col-12 mt-10" *ngFor="let data of bookingsData">
                <div class="card px-15" [ngClass]="{
                    bt_pending: data.booking.status === 'P',
                    bt_unfilled: ['U', 'C'].includes(data.booking.status),
                    bt_in_progress: data.booking.status === 'I'
                  }">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <p class="user-title-m">
                        {{ data.booking.strategy }}
                        <span *ngIf="data.booking.is_closed" class="booking-status-closed">Closed</span>
                        <ng-container *ngIf="!data.booking.is_closed">
                          <span *ngIf="data.booking.flexi_booking; else newBooking" class="booking-status-flexi">Flexi
                            booking</span>
                          <ng-template #newBooking>
                            <span class="booking-status-new interval-time">New</span>
                          </ng-template>

                          <ng-container *ngIf="
                              data.booking.invite_count > 1 &&
                                data.booking.strategy ===
                                  'One at a time request';
                              else showInvited
                            ">
                            @if(!schoolProps.properties.is_qld_teacher){
                              <span class="interval-time">Invites are sent to candidates in {{ data.delay }} mins intervals.</span>
                            }
                          </ng-container>
                          <ng-template #showInvited>
                            <span class="interval-time">{{ data.booking.invite_count }} invited</span>
                          </ng-template>
                        </ng-container>
                      </p>

                      <p class="txt-regular">
                        {{ data.booking.booking_role_type }}
                      </p>
                      <hr class="m-1" />
                      <!-- Invite From Not in My List -->
                      <div class="info-banner" *ngIf="data?.is_expand_booking_type">
                        <i class="bi bi-info-circle-fill info-banner-icon"></i>
                        <div class="info-banner-content">
                          <p class="info-banner-title">This school is not on your schools’ list</p>
                          <p class="info-banner-text">This booking request is from a school outside your saved preferences. They found you through expanded search.</p>
                        </div>
                      </div>

                      <div class="d-flex align-items-center mt-10 flex-wrap">
                        <img [src]="
                            data.booking.school.profile_image ||
                            'assets/images/pro_avatar.png'
                          " alt="School Logo" class="me-2" style="
                            width: 32px;
                            height: 32px;
                            object-fit: contain;
                            border-radius: 50%;
                          " />
                        <h5 class="user-title align-self-center mb-0 profile_image_50">
                          {{ data.booking.school.title }}
                        </h5>
                      </div>

                      <div class="d-flex table-content flex-wrap">
                        <div class="mt-12">
                          <p class="sub_title_card">DATE</p>
                          <p class="text-regular-medium mt-5">
                            <ng-container *ngIf="isArrayFormat(data.booking?.booking_dates); else oldFormat">
                              <ng-container *ngFor="let dateGroup of data.booking.booking_dates">
                                <span>{{ dateGroup }}</span><br />
                              </ng-container>
                            </ng-container>

                            <ng-template #oldFormat>
                            <span>{{ data.booking?.booking_dates  }}</span>
                            </ng-template>
                          </p>
                        </div>
                        <div class="mt-12">
                          <p class="sub_title_card">TIME</p>
                          <p class="text-regular-medium mt-5">
                            {{ data.booking.booking_time }}
                          </p>
                        </div>
                        <div class="mt-12">
                          <p class="sub_title_card">CLASS BEING COVERED</p>
                          <ng-container *ngIf="data.booking.flexi_booking; else showClass">
                            <p class="text-regular-medium mt-5">
                              Flexi-booking
                              <i placement="top"
                                ngbTooltip="This booking was sent as a Flexi Booking, which means the class and teacher being covered are not yet confirmed."
                                class="bi bi-info-circle-fill ml-6 fs-16 clr-cc-vilot" title=></i>
                            </p>
                          </ng-container>
                          <ng-template #showClass>
                            <p class="text-regular-medium mt-5">
                              {{ data.information.class_being_covered }}
                            </p>
                          </ng-template>
                        </div>
                        <div class="mt-12">
                          <p class="sub_title_card">TEACHER BEING COVERED</p>
                          <ng-container *ngIf="data.booking.flexi_booking; else showTeacher">
                            <p class="text-regular-medium mt-5">
                              Flexi-booking
                              <i placement="top" appFocus appClick
                                class="bi bi-info-circle-fill ml-6 fs-16 clr-cc-vilot"
                                ngbTooltip="This booking was sent as a Flexi Booking, which means the class and teacher being covered are not yet confirmed."></i>
                            </p>
                          </ng-container>
                          <ng-template #showTeacher>
                            <p class="text-regular-medium mt-5">
                              {{ data.information.provider_being_covered }}
                            </p>
                          </ng-template>
                        </div>
                      </div>

                      <div [ngClass]="[
                          'd-flex',
                          'mt-12',
                          data.booking.invite_count > 1 &&
                          data.status === 'Sent'
                            ? 'mb-35'
                            : ''
                        ]">
                        <!-- @if(data.status === 'Processing'){
                        <button class="btn-outline fs-14">
                          Processing
                        </button>
                        }@else { -->
                        <button class="cc_p_btn fs-14" (click)="onAcceptBooking(data.unique_code, data.id)">
                          {{
                          data.booking.invite_count > 1 && !schoolProps.properties.is_qld_teacher ? "Apply" : "Accept"
                          }}
                        </button>
                        <button class="btn-outline ml-10" (click)="
                            openBookingDeclineModal(data.unique_code, data.id)
                          ">
                          Decline
                        </button>
                        <!-- } -->
                      </div>
                    </div>
                  </div>
                  <div *ngIf="
                      data.booking.invite_count > 1 && data.status === 'Sent'
                    " class="text-center txt-regular emailed">
                    <span>You will be emailed when you're booked.</span>
                  </div>
                </div>
              </div>
            </ng-container>
            <!-- Pagination for Pending Bookings -->
            <div class="row">
              <div class="col-lg-12">
                <pagination *ngIf="bookingsData.length > 0" class="mt-20 pagination-sm" [totalItems]="totalCount"
                  [boundaryLinks]="true" [rotate]="true" [maxSize]="5" [(ngModel)]="currentPage"
                  (pageChanged)="pageChanged($event)">
                </pagination>
              </div>
            </div>
            <ng-template #noPending>
              <div class="col-12 mt-10">
                <div class="card px-30">
                  <div class="no-bookings text-center">
                    <ng-container>
                      <ng-container>
                        <img src="assets/images/CCPI_PendingRequests_NoAcceptedRequests_.png" width="200"
                          alt="No bookings {{selectedBookingStatus}}" class="no-bookings-image" />
                      </ng-container>
                    </ng-container>
                    <ng-container>
                      <ng-container>
                        <p class="no-bookings-text">You have no booking requests</p>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>

          <!-- Booked and Not Booked -->
          <ng-container *ngSwitchDefault>
            <ng-container *ngIf="bookingsData.length > 0; else noBooked">
              <div class="col-12 mt-10" *ngFor="let data of bookingsData">
                <div class="booking-card">
                  <div class="card-container">
                    <img [src]="
                        data.booking.school.profile_image ||
                        'assets/images/pro_avatar.png'
                      " alt="School logo" class="school-logo" />
                    <div class="card-details">
                      <div class="school-header">
                        <p class="school-name">
                          {{ data.booking.school.title }}
                        </p>
                        <span class="color-booking-status-{{ data.status }}">{{
                          data.status
                          }}</span>
                      </div>
                      <div class="schedule">
                        <span>{{ data.booking.booking_dates }},
                          {{ data.booking.booking_time }}</span>
                        <span class="divider">|</span>
                        <span>{{ data.booking.booking_role_type }}</span>
                        <span class="divider">|</span>
                        <span>{{
                          data.status == "Declined"
                          ? "Declined on"
                          : "Accepted on"
                          }}
                          : {{ data.response_time }}</span>
                      </div>
                      <div class="location">
                        <span>{{ data.booking.school.address }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #noBooked>
              <div class="col-12 mt-10">
                <div class="card px-30">
                  <div class="no-bookings text-center">
                    <ng-container>
                      <img *ngIf="selectedBookingStatus === 'B'" src="assets/FindNew_NoMacthesFound.png" width="200"
                        alt="No confirmed bookings" class="no-bookings-image" />
                      <img *ngIf="selectedBookingStatus === 'NB'" src="assets/SmartGroups_NoBackupList.png" width="150"
                        alt="No not booked" class="no-bookings-image" />
                    </ng-container>
                    <ng-container [ngSwitch]="selectedBookingStatus">
                      <ng-container *ngSwitchCase="'B'">
                        <h4 class="no-bookings-text fs-17">No confirmed bookings yet</h4>
                        <p class="no-bookings-subtext">Confirmed bookings will show up here. Keep an eye on your
                          Pending
                          tab for new requests!</p>
                      </ng-container>
                      <ng-container *ngSwitchCase="'NB'">
                        <h4 class="no-bookings-text  fs-17 mt-20">Nothing to see here yet.</h4>
                        <p class="no-bookings-subtext">Details for requests where you weren't booked will appear here.
                        </p>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-template>
            <!-- Pagination for Booked/Not Booked -->
            <div class="row">
              <div class="col-lg-12">
                <pagination *ngIf="bookingsData.length > 0" class="mt-20 pagination-sm" [totalItems]="totalCount"
                  [boundaryLinks]="true" [rotate]="true" [maxSize]="5" [(ngModel)]="currentPage"
                  (pageChanged)="pageChanged($event)">
                </pagination>
              </div>
            </div>
            <ng-template #noBooked>
              <div class="col-12 mt-10">
                <div class="no-bookings text-center">
                  <img src="assets/images/CCPI_PendingRequests_NoAcceptedRequests_.svg" alt="No bookings"
                    class="no-bookings-image" />
                  <!-- <p class="no-bookings-text">
                    {{
                    selectedBookingStatus === "B"
                    ? "Your bookings will show here once you begin accepting them. Expand your booking request
                    opportunities by connecting with new schools."
                    : "Booking requests you've declined will appear here. Expand your booking request opportunities by
                    connecting with new schools."
                    }}
                  </p> -->
                </div>
              </div>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>

      <!-- Right Sidebar: Availability Check -->
      <div class="col-lg-4 col-md-4 col-sm-12 mt-10">
        <app-quick-availability-update (availabilityUpdated)="refreshPage()"
          [stats]="this.sideComponentData"></app-quick-availability-update>
        <!-- <div class="card px-12 health-check-card">
          <div class="row mb-3">
            <div class="col-9">
              <p class="user-title-m fs-16">Availability health check</p>
              <p class="mb-10 txt-regular fs-12">
                You have
                <strong
                  >{{ sideComponentData?.hasnotindicated_count }} days</strong
                >
                where you haven't indicated. Make sure you update your calendar.
              </p>
              <a class="user-title c-p clr-cc-vilot" (click)="goToCalendar()">
                Quick update your availability
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-arrow-right"
                  viewBox="0 0 16 17"
                  stroke="currentColor"
                  stroke-width="1"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                  />
                </svg>
              </a>
            </div>
            <div class="col-3 text-end">
              <div class="progress-circle-container">
                <svg class="progress-ring" width="80" height="80">
                  <circle
                    class="progress-ring__background"
                    cx="40"
                    cy="40"
                    r="35"
                  />
                  <circle
                    class="progress-ring__circle"
                    cx="40"
                    cy="40"
                    r="35"
                    stroke="#4caf50"
                    stroke-width="8"
                    fill="none"
                    [attr.stroke-dasharray]="
                      getSmallProfileDashArray(
                        sideComponentData?.hasnotindicated_percentage
                      )
                    "
                    [attr.stroke-dashoffset]="
                      getSmallProfileDashOffset(
                        sideComponentData?.hasnotindicated_percentage
                      )
                    "
                    transform="rotate(-90 40 40)"
                  />
                </svg>
                <div class="progress-label">
                  <div class="fw-bold">
                    {{ 100 - sideComponentData?.hasnotindicated_percentage }}%
                  </div>
                  <small class="fs-10">Availability<br />Indicated</small>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>

<!-- Decline Modal Template -->
<ng-template #declineBookingModal>
  <form [formGroup]="declineBookingForm">
    <div class="modal-header">
      <h4 class="modal-title">Decline booking request</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.hide()"></button>
    </div>
    <hr />
    <div class="modal-body">
      <label for="declineReason" class="form-label text-regular-medium">Reason for declining the booking request</label>
      <textarea id="declineReason" formControlName="decline_reason" class="form-control mt-15" maxlength="700"
        placeholder="Add Message here..." rows="10">
      </textarea>
    </div>
    <div class="modal-footer mt-10">
      <button type="button" class="btn cc_p_btn fs_13" (click)="onConfirmBookingDecline(responseCode, bookingId)">
        Confirm
      </button>
    </div>
  </form>
</ng-template>